export default {
  dataProcessingApi: {
    source: {
      drivers: '/api/dataprocessing/source/drivers',
      getList: '/api/dataprocessing/source/getList',
      state: '/api/dataprocessing/source/state',
      terminate: '/api/dataprocessing/source/terminate',
      control: '/api/dataprocessing/source/control',
      getDetail: '/api/dataprocessing/source/getDetail',
      synchro: '/api/dataprocessing/source/synchro'
    },
    sqlRtDriver: {
      sqlTypes: '/api/sqlRtDriver/sqlTypes',
      sqlRtSaveOrUpdate: 'api/sqlRtDriver/sqlRtSaveOrUpdate',
      getTagList: '/api/sqlRtDriver/getTagList',
      getTables: '/api/sqlRtDriver/getTables',
      getColumns: '/api/sqlRtDriver/getColumns',
      tagSaveOrUpdate: '/api/sqlRtDriver/tagSaveOrUpdate',
      retransmission: '/api/sqlRtDriver/retransmission',
      tagDels: '/api/sqlRtDriver/tagDels',
      getMetricList: '/api/sqlRtDriver/getMetricList',
      metricsDel: '/api/sqlRtDriver/metricsDel',
      metricUpdate: '/api/sqlRtDriver/metricUpdate',
    },
    sqlToSqlDriver: {
      sqlToSqlSaveOrUpdate: 'api/sqlToSqlDriver/sqlToSqlSaveOrUpdate',
      sqlTypes: '/api/sqlToSqlDriver/sqlTypes',
      getDataBases: 'api/sqlToSqlDriver/getDataBases',
      saveOrUpdateDataBase: 'api/sqlToSqlDriver/saveOrUpdateDataBase',
      dataBaseTerminate: 'api/sqlToSqlDriver/dataBaseTerminate',
      getTableKeyList: '/api/sqlToSqlDriver/getTableKeyList',
      tableKeySaveOrUpdate: '/api/sqlToSqlDriver/tableKeySaveOrUpdate',
      tableKeyTerminate: '/api/sqlToSqlDriver/tableKeyTerminate',
      getDataBasesOpt: '/api/sqlToSqlDriver/getDataBasesOpt',
      getDataBaseTables: '/api/sqlToSqlDriver/getDataBaseTables',
      getColumns: '/api/sqlToSqlDriver/getColumns',
      retransmission: '/api/sqlToSqlDriver/retransmission',
      getMetricList: '/api/sqlToSqlDriver/getMetricList',
      metricsDel: '/api/sqlToSqlDriver/metricsDel',
      metricUpdate: '/api/sqlToSqlDriver/metricUpdate',
    },
    tag: {
      getSourceOptions: '/api/dataprocessing/tag/getSourceOptions',
      getValueTypeOptions: '/api/dataprocessing/tag/getValueTypeOptions',
      getList: '/api/dataprocessing/tag/getList',
      getDataPoints: '/api/dataprocessing/tag/getDataPoints'
    },
    aberrant: {
      getFilterOptions: 'api/preprocessing/aberrant/getFilterOptions',
      getList: 'api/preprocessing/aberrant/getList',
      getAberrant: 'api/preprocessing/aberrant/getAberrant',
      history: 'api/preprocessing/aberrant/history/getValue'
    }
  }
}